// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton_closeButton__nDEOc","icon":"closeButton_icon__IC66d"};